import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertRecordService } from '../../../alert-record.service';
@Component({
  selector: 'alert-record-items',
  templateUrl: './alert-record-items.component.html',
  styleUrls: ['./alert-record-items.component.scss'],
})
export class AlertRecordItemsComponent implements OnInit {
  record: any[];
  constructor(
    private readonly route: ActivatedRoute,
    private readonly alertRecordService: AlertRecordService
  ) {
    this.id = route.snapshot.paramMap.get('id');
    this.getAlertRecord();
  }
  id;
  ngOnInit() {
    this.alertRecordService.updatedRecord.subscribe({
      next: (update) => {
        console.log('funciona el subject');

        this.getAlertRecord();
      },
    });
  }
  getAlertRecord() {
    this.alertRecordService.getAllAlertRecord(this.id).subscribe({
      next: (record) => {
        this.record = record;
      },
    });
  }
}
